import React, { ReactNode } from 'react';

import '@/css/loginRequiredModalStyle.css';
import { Dialog, Fade } from '@mui/material';

interface LoginRequiredModalProps {
  isOpen: boolean;
  title?: string;
  description?: ReactNode;
  cancelLabel?: string;
  confirmLabel?: string;
  onCancel: () => void;
  onConfirm: () => void;
}

const LoginRequiredModal = ({
  isOpen,
  title = '로그인이 필요합니다',
  description,
  cancelLabel = '취소',
  confirmLabel = '로그인하기',
  onCancel,
  onConfirm,
}: LoginRequiredModalProps) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onCancel}
      aria-labelledby="login-required-dialog-title"
      aria-describedby="login-required-dialog-description"
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 100 }}
      PaperProps={{ className: 'login-required-modal' }}
    >
      <h2
        id="login-required-dialog-title"
        className="font-bold break-keep text-gray-9 text-[24px] leading-[32px] sm280:text-[20px] sm280:leading-[28px]"
      >
        {title}
      </h2>
      <p
        id="login-required-dialog-description"
        className="mt-[16px] break-keep whitespace-pre-line text-gray-7 text-[18px] leading-[26px] sm280:text-[15px] sm280:leading-[22px]"
      >
        {description}
      </p>
      <div className="flex gap-[12px] mt-[32px] sm280:mt-[24px]">
        <button
          type="button"
          onClick={onCancel}
          className="w-full py-[14px] border rounded-[10px] border-gray-3 text-gray-7 font-medium text-[18px] leading-[24px] sm280:text-[16px] sm280:py-[12px]"
        >
          {cancelLabel}
        </button>
        <button
          type="button"
          onClick={onConfirm}
          className="w-full py-[14px] rounded-[10px] bg-[#4762EF] text-white font-semibold text-[18px] leading-[24px] sm280:text-[16px] sm280:py-[12px]"
        >
          {confirmLabel}
        </button>
      </div>
    </Dialog>
  );
};

export default LoginRequiredModal;
